
// @ts-nocheck


export const localeCodes =  [
  "cs",
  "en",
  "hu",
  "pl",
  "ro",
  "sk",
  "fr",
  "es",
  "de",
  "at",
  "uk",
  "it",
  "bg"
]

export const localeLoaders = {
  cs: [
    {
      key: "locale_cs_46json_27362e6b",
      load: () => import("#nuxt-i18n/27362e6b" /* webpackChunkName: "locale_cs_46json_27362e6b" */),
      cache: true
    },
    {
      key: "locale_cs_46json_a3157631",
      load: () => import("#nuxt-i18n/a3157631" /* webpackChunkName: "locale_cs_46json_a3157631" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_322b2349",
      load: () => import("#nuxt-i18n/322b2349" /* webpackChunkName: "locale_en_46json_322b2349" */),
      cache: true
    },
    {
      key: "locale_en_46json_66102171",
      load: () => import("#nuxt-i18n/66102171" /* webpackChunkName: "locale_en_46json_66102171" */),
      cache: true
    }
  ],
  hu: [
    {
      key: "locale_hu_46json_9198584c",
      load: () => import("#nuxt-i18n/9198584c" /* webpackChunkName: "locale_hu_46json_9198584c" */),
      cache: true
    },
    {
      key: "locale_hu_46json_d30160a4",
      load: () => import("#nuxt-i18n/d30160a4" /* webpackChunkName: "locale_hu_46json_d30160a4" */),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46json_fce412a0",
      load: () => import("#nuxt-i18n/fce412a0" /* webpackChunkName: "locale_pl_46json_fce412a0" */),
      cache: true
    },
    {
      key: "locale_pl_46json_a53212b8",
      load: () => import("#nuxt-i18n/a53212b8" /* webpackChunkName: "locale_pl_46json_a53212b8" */),
      cache: true
    }
  ],
  ro: [
    {
      key: "locale_ro_46json_bfa891e6",
      load: () => import("#nuxt-i18n/bfa891e6" /* webpackChunkName: "locale_ro_46json_bfa891e6" */),
      cache: true
    },
    {
      key: "locale_ro_46json_de1968d7",
      load: () => import("#nuxt-i18n/de1968d7" /* webpackChunkName: "locale_ro_46json_de1968d7" */),
      cache: true
    }
  ],
  sk: [
    {
      key: "locale_sk_46json_bd155160",
      load: () => import("#nuxt-i18n/bd155160" /* webpackChunkName: "locale_sk_46json_bd155160" */),
      cache: true
    },
    {
      key: "locale_sk_46json_a38ab0b9",
      load: () => import("#nuxt-i18n/a38ab0b9" /* webpackChunkName: "locale_sk_46json_a38ab0b9" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_2502d1c2",
      load: () => import("#nuxt-i18n/2502d1c2" /* webpackChunkName: "locale_fr_46json_2502d1c2" */),
      cache: true
    },
    {
      key: "locale_fr_46json_6c2ab992",
      load: () => import("#nuxt-i18n/6c2ab992" /* webpackChunkName: "locale_fr_46json_6c2ab992" */),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_2e1b76f1",
      load: () => import("#nuxt-i18n/2e1b76f1" /* webpackChunkName: "locale_es_46json_2e1b76f1" */),
      cache: true
    },
    {
      key: "locale_es_46json_1d1ff1c1",
      load: () => import("#nuxt-i18n/1d1ff1c1" /* webpackChunkName: "locale_es_46json_1d1ff1c1" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_a6e79afa",
      load: () => import("#nuxt-i18n/a6e79afa" /* webpackChunkName: "locale_de_46json_a6e79afa" */),
      cache: true
    },
    {
      key: "locale_de_46json_3e0ea50a",
      load: () => import("#nuxt-i18n/3e0ea50a" /* webpackChunkName: "locale_de_46json_3e0ea50a" */),
      cache: true
    }
  ],
  at: [
    {
      key: "locale_de_46json_3e0ea50a",
      load: () => import("#nuxt-i18n/3e0ea50a" /* webpackChunkName: "locale_de_46json_3e0ea50a" */),
      cache: true
    }
  ],
  uk: [
    {
      key: "locale_uk_46json_c888bfd0",
      load: () => import("#nuxt-i18n/c888bfd0" /* webpackChunkName: "locale_uk_46json_c888bfd0" */),
      cache: true
    },
    {
      key: "locale_uk_46json_1dbcf31e",
      load: () => import("#nuxt-i18n/1dbcf31e" /* webpackChunkName: "locale_uk_46json_1dbcf31e" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_0e8d773e",
      load: () => import("#nuxt-i18n/0e8d773e" /* webpackChunkName: "locale_it_46json_0e8d773e" */),
      cache: true
    },
    {
      key: "locale_it_46json_16e8136a",
      load: () => import("#nuxt-i18n/16e8136a" /* webpackChunkName: "locale_it_46json_16e8136a" */),
      cache: true
    }
  ],
  bg: [
    {
      key: "locale_bg_46json_471003cd",
      load: () => import("#nuxt-i18n/471003cd" /* webpackChunkName: "locale_bg_46json_471003cd" */),
      cache: true
    },
    {
      key: "locale_bg_46json_aaca624c",
      load: () => import("#nuxt-i18n/aaca624c" /* webpackChunkName: "locale_bg_46json_aaca624c" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/ebe6c25c" /* webpackChunkName: "config_i18n_46config_46ts_ebe6c25c" */)
]

export const nuxtI18nOptions = {
  restructureDir: "./",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "cs",
      language: "cs-CZ",
      name: "Czech",
      nativeName: "Čeština",
      dir: "ltr",
      country: "CZ",
      currency: "CZK",
      flag: "circle-flags:cz",
      files: [
        {
          path: "/usr/local/app/layers/i18n/locales/cs.json",
          cache: undefined
        },
        {
          path: "/usr/local/app/apps/uzo.com/i18n/locales/cs.json",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      language: "en-US",
      name: "English",
      nativeName: "English",
      dir: "ltr",
      country: "US",
      currency: "USD",
      flag: "circle-flags:us",
      files: [
        {
          path: "/usr/local/app/layers/i18n/locales/en.json",
          cache: undefined
        },
        {
          path: "/usr/local/app/apps/uzo.com/i18n/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "hu",
      language: "hu-HU",
      name: "Hungarian",
      nativeName: "Magyar",
      dir: "ltr",
      country: "HU",
      currency: "HUF",
      flag: "circle-flags:hu",
      files: [
        {
          path: "/usr/local/app/layers/i18n/locales/hu.json",
          cache: undefined
        },
        {
          path: "/usr/local/app/apps/uzo.com/i18n/locales/hu.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pl",
      language: "pl-PL",
      name: "Polish",
      nativeName: "Polski",
      dir: "ltr",
      country: "PL",
      currency: "PLN",
      flag: "circle-flags:pl",
      files: [
        {
          path: "/usr/local/app/layers/i18n/locales/pl.json",
          cache: undefined
        },
        {
          path: "/usr/local/app/apps/uzo.com/i18n/locales/pl.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ro",
      language: "ro-RO",
      name: "Romanian",
      nativeName: "Română",
      dir: "ltr",
      country: "RO",
      currency: "RON",
      flag: "circle-flags:ro",
      files: [
        {
          path: "/usr/local/app/layers/i18n/locales/ro.json",
          cache: undefined
        },
        {
          path: "/usr/local/app/apps/uzo.com/i18n/locales/ro.json",
          cache: undefined
        }
      ]
    },
    {
      code: "sk",
      language: "sk-SK",
      name: "Slovak",
      nativeName: "Slovenčina",
      dir: "ltr",
      country: "SK",
      currency: "EUR",
      flag: "circle-flags:sk",
      files: [
        {
          path: "/usr/local/app/layers/i18n/locales/sk.json",
          cache: undefined
        },
        {
          path: "/usr/local/app/apps/uzo.com/i18n/locales/sk.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      language: "fr-FR",
      name: "French",
      nativeName: "Français",
      dir: "ltr",
      country: "FR",
      currency: "EUR",
      flag: "circle-flags:fr",
      files: [
        {
          path: "/usr/local/app/layers/i18n/locales/fr.json",
          cache: undefined
        },
        {
          path: "/usr/local/app/apps/uzo.com/i18n/locales/fr.json",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      language: "es-ES",
      name: "Spanish",
      nativeName: "Español",
      dir: "ltr",
      country: "ES",
      currency: "EUR",
      flag: "circle-flags:es",
      files: [
        {
          path: "/usr/local/app/layers/i18n/locales/es.json",
          cache: undefined
        },
        {
          path: "/usr/local/app/apps/uzo.com/i18n/locales/es.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      language: "de-DE",
      name: "German",
      nativeName: "Deutsch",
      dir: "ltr",
      country: "DE",
      currency: "EUR",
      flag: "circle-flags:de",
      files: [
        {
          path: "/usr/local/app/layers/i18n/locales/de.json",
          cache: undefined
        },
        {
          path: "/usr/local/app/apps/uzo.com/i18n/locales/de.json",
          cache: undefined
        }
      ]
    },
    {
      code: "at",
      language: "de-AT",
      name: "German",
      nativeName: "Deutsch",
      dir: "ltr",
      country: "AT",
      currency: "EUR",
      flag: "circle-flags:at",
      files: [
        {
          path: "/usr/local/app/apps/uzo.com/i18n/locales/de.json",
          cache: undefined
        }
      ]
    },
    {
      code: "uk",
      language: "uk-UA",
      name: "Ukrainian",
      nativeName: "Українська",
      dir: "ltr",
      country: "UA",
      currency: "UAH",
      flag: "circle-flags:ua",
      files: [
        {
          path: "/usr/local/app/layers/i18n/locales/uk.json",
          cache: undefined
        },
        {
          path: "/usr/local/app/apps/uzo.com/i18n/locales/uk.json",
          cache: undefined
        }
      ]
    },
    {
      code: "it",
      language: "it-IT",
      name: "Italian",
      nativeName: "Italiano",
      dir: "ltr",
      country: "IT",
      currency: "EUR",
      flag: "circle-flags:it",
      files: [
        {
          path: "/usr/local/app/layers/i18n/locales/it.json",
          cache: undefined
        },
        {
          path: "/usr/local/app/apps/uzo.com/i18n/locales/it.json",
          cache: undefined
        }
      ]
    },
    {
      code: "bg",
      language: "bg-BG",
      name: "Bulgarian",
      nativeName: "Български",
      dir: "ltr",
      country: "BG",
      currency: "BGN",
      flag: "circle-flags:bg",
      files: [
        {
          path: "/usr/local/app/layers/i18n/locales/bg.json",
          cache: undefined
        },
        {
          path: "/usr/local/app/apps/uzo.com/i18n/locales/bg.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "locale",
    cookieSecure: false,
    fallbackLocale: "en",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "cs",
    language: "cs-CZ",
    name: "Czech",
    nativeName: "Čeština",
    dir: "ltr",
    country: "CZ",
    currency: "CZK",
    flag: "circle-flags:cz",
    files: [
      {
        path: "/usr/local/app/layers/i18n/locales/cs.json",
        cache: undefined
      },
      {
        path: "/usr/local/app/apps/uzo.com/i18n/locales/cs.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    language: "en-US",
    name: "English",
    nativeName: "English",
    dir: "ltr",
    country: "US",
    currency: "USD",
    flag: "circle-flags:us",
    files: [
      {
        path: "/usr/local/app/layers/i18n/locales/en.json",
        cache: undefined
      },
      {
        path: "/usr/local/app/apps/uzo.com/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "hu",
    language: "hu-HU",
    name: "Hungarian",
    nativeName: "Magyar",
    dir: "ltr",
    country: "HU",
    currency: "HUF",
    flag: "circle-flags:hu",
    files: [
      {
        path: "/usr/local/app/layers/i18n/locales/hu.json",
        cache: undefined
      },
      {
        path: "/usr/local/app/apps/uzo.com/i18n/locales/hu.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pl",
    language: "pl-PL",
    name: "Polish",
    nativeName: "Polski",
    dir: "ltr",
    country: "PL",
    currency: "PLN",
    flag: "circle-flags:pl",
    files: [
      {
        path: "/usr/local/app/layers/i18n/locales/pl.json",
        cache: undefined
      },
      {
        path: "/usr/local/app/apps/uzo.com/i18n/locales/pl.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ro",
    language: "ro-RO",
    name: "Romanian",
    nativeName: "Română",
    dir: "ltr",
    country: "RO",
    currency: "RON",
    flag: "circle-flags:ro",
    files: [
      {
        path: "/usr/local/app/layers/i18n/locales/ro.json",
        cache: undefined
      },
      {
        path: "/usr/local/app/apps/uzo.com/i18n/locales/ro.json",
        cache: undefined
      }
    ]
  },
  {
    code: "sk",
    language: "sk-SK",
    name: "Slovak",
    nativeName: "Slovenčina",
    dir: "ltr",
    country: "SK",
    currency: "EUR",
    flag: "circle-flags:sk",
    files: [
      {
        path: "/usr/local/app/layers/i18n/locales/sk.json",
        cache: undefined
      },
      {
        path: "/usr/local/app/apps/uzo.com/i18n/locales/sk.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    language: "fr-FR",
    name: "French",
    nativeName: "Français",
    dir: "ltr",
    country: "FR",
    currency: "EUR",
    flag: "circle-flags:fr",
    files: [
      {
        path: "/usr/local/app/layers/i18n/locales/fr.json",
        cache: undefined
      },
      {
        path: "/usr/local/app/apps/uzo.com/i18n/locales/fr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    language: "es-ES",
    name: "Spanish",
    nativeName: "Español",
    dir: "ltr",
    country: "ES",
    currency: "EUR",
    flag: "circle-flags:es",
    files: [
      {
        path: "/usr/local/app/layers/i18n/locales/es.json",
        cache: undefined
      },
      {
        path: "/usr/local/app/apps/uzo.com/i18n/locales/es.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    language: "de-DE",
    name: "German",
    nativeName: "Deutsch",
    dir: "ltr",
    country: "DE",
    currency: "EUR",
    flag: "circle-flags:de",
    files: [
      {
        path: "/usr/local/app/layers/i18n/locales/de.json",
        cache: undefined
      },
      {
        path: "/usr/local/app/apps/uzo.com/i18n/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "at",
    language: "de-AT",
    name: "German",
    nativeName: "Deutsch",
    dir: "ltr",
    country: "AT",
    currency: "EUR",
    flag: "circle-flags:at",
    files: [
      {
        path: "/usr/local/app/apps/uzo.com/i18n/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "uk",
    language: "uk-UA",
    name: "Ukrainian",
    nativeName: "Українська",
    dir: "ltr",
    country: "UA",
    currency: "UAH",
    flag: "circle-flags:ua",
    files: [
      {
        path: "/usr/local/app/layers/i18n/locales/uk.json",
        cache: undefined
      },
      {
        path: "/usr/local/app/apps/uzo.com/i18n/locales/uk.json",
        cache: undefined
      }
    ]
  },
  {
    code: "it",
    language: "it-IT",
    name: "Italian",
    nativeName: "Italiano",
    dir: "ltr",
    country: "IT",
    currency: "EUR",
    flag: "circle-flags:it",
    files: [
      {
        path: "/usr/local/app/layers/i18n/locales/it.json",
        cache: undefined
      },
      {
        path: "/usr/local/app/apps/uzo.com/i18n/locales/it.json",
        cache: undefined
      }
    ]
  },
  {
    code: "bg",
    language: "bg-BG",
    name: "Bulgarian",
    nativeName: "Български",
    dir: "ltr",
    country: "BG",
    currency: "BGN",
    flag: "circle-flags:bg",
    files: [
      {
        path: "/usr/local/app/layers/i18n/locales/bg.json",
        cache: undefined
      },
      {
        path: "/usr/local/app/apps/uzo.com/i18n/locales/bg.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/